import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { get, del, put } from '../../controllers/apiController';

import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

const Etiketler = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [etiketler, setEtiketler] = useState([]);
    const [selectedEtiket, setSelectedEtiket] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);

    useEffect(() => {
        document.title = "Etiketler | LEVELUP CRM";

        const fetchEtiketler = async () => {
            try {
                const res = await get("labels/");

                const etiketlerMapped = res.map(etiket => {
                    return {
                        id: etiket.Etiket_ID,
                        ad: etiket.Etiket_Adi,
                        arkaRenk: "#" + etiket.Etiket_Renk,
                        yaziRenk: "#" + etiket.Etiket_Yazi_Renk
                    }
                });

                setEtiketler(etiketlerMapped);

                setIsLoading(false);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
        }

        fetchEtiketler();
    }, []);

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Etiket Silinsin mi?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await del(`labels/${id}`);

                setEtiketler(etiketler.filter(etiket => etiket.id !== id));

                toast.success('Etiket başarıyla silindi');
            }
        })

    }

    const handleEdit = (etiket) => {
        setSelectedEtiket(etiket);
        setShowEditModal(true);
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {
            await put('labels/', {
                labelId: selectedEtiket.id,
                labelName: selectedEtiket.ad,
                labelBgColor: selectedEtiket.arkaRenk.replace('#', ''),
                labelTextColor: selectedEtiket.yaziRenk.replace('#', '')
            });

            setEtiketler(etiketler.map(etiket =>
                etiket.id === selectedEtiket.id ? selectedEtiket : etiket
            ));

            setShowEditModal(false);
            toast.success('Etiket başarıyla güncellendi');
        } catch (error) {
            toast.error('Etiket güncellenirken bir hata oluştu');
        }
    }

    const columns = [
        {
            name: 'Etiket Önizlemesi',
            sortable: true,
            cell: row => (
                <div
                    style={{
                        backgroundColor: row.arkaRenk,
                        borderRadius: '6px',
                        padding: '8px 12px',
                        color: row.yaziRenk,
                        fontSize: '14px'
                    }}
                >
                    {row.ad}
                </div>
            )
        },
        {
            name: 'Aksiyon',
            cell: row => (
                <div className="d-flex gap-2">
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleEdit(row)}>
                        <i className="feather feather-edit fs-6"></i>
                    </a>
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleDelete(row.id)}>
                        <i className="feather feather-trash fs-6"></i>
                    </a>
                </div>
            )
        }
    ];

    const modalBackdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1040
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Etiketler</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Tüm Etiketler</h5>
                                        <div className="card-header-action">
                                            <a href="./create-label" className="btn btn-light">
                                                <i className="feather-plus"></i>
                                                Yeni Ekle
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={etiketler}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {showEditModal && selectedEtiket && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Etiket Düzenle</h5>
                                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                            </div>
                            <form onSubmit={handleEditSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Etiket Adı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={selectedEtiket.ad}
                                            onChange={(e) => setSelectedEtiket({ ...selectedEtiket, ad: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Arka Plan Rengi</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color w-100"
                                            value={selectedEtiket.arkaRenk}
                                            onChange={(e) => setSelectedEtiket({ ...selectedEtiket, arkaRenk: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Yazı Rengi</label>
                                        <input
                                            type="color"
                                            className="form-control form-control-color w-100"
                                            value={selectedEtiket.yaziRenk}
                                            onChange={(e) => setSelectedEtiket({ ...selectedEtiket, yaziRenk: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary">Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {showEditModal && (
                <div style={modalBackdropStyle} onClick={() => setShowEditModal(false)} />
            )}
        </Layout>
    );
};

export default Etiketler;
